module.exports = __webpack_public_path__ + "img/Mask-Group-3.46911ec2.png";